var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdeaGeneratorGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#ADD095"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1881 8L11.3779 9.79762L14.0714 12.4749L15.8791 10.6772L13.1881 8ZM36.8131 8L34.1196 10.6772L35.9286 12.4749L38.6209 9.79889L36.8131 8ZM25 8.7978C24.5757 8.80121 24.1471 8.82849 23.7143 8.87963H23.6757C18.4609 9.47415 14.3106 13.6639 13.5893 18.8266C13.0133 22.9818 14.7361 26.7497 17.6071 29.1763C18.7814 30.1731 19.5757 31.5407 19.8571 33.0503V40.7215H22.7886C23.236 41.4848 24.0524 42 25 42C25.9476 42 26.764 41.4848 27.2114 40.7215H30.1429V35.6073H30.2637V34.0884C30.2637 32.2141 31.2434 30.3244 32.8351 28.8554C34.9643 26.7356 36.5714 23.7247 36.5714 20.2662C36.5714 13.9503 31.3437 8.73899 25 8.7978ZM25 11.3549C29.9693 11.2858 34 15.3311 34 20.2662C34 22.9435 32.7529 25.3011 31.0261 27.0169L31.0673 27.0578C29.352 28.6318 28.2426 30.7515 27.9301 33.0516H22.3064C22.0236 30.8602 21.0786 28.7391 19.2927 27.2176C17.0209 25.2998 15.667 22.4103 16.1196 19.1475C16.6814 15.1201 19.9677 11.8816 23.9946 11.438C24.3271 11.3921 24.6619 11.3648 24.9974 11.3561L25 11.3549ZM7 20.2662V22.8233H10.8571V20.2662H7ZM39.1429 20.2662V22.8233H43V20.2662H39.1429ZM14.0714 30.6147L11.3791 33.2906L13.1881 35.0895L15.8779 32.4123L14.0714 30.6147ZM35.9286 30.6147L34.1209 32.4123L36.8119 35.0895L38.6209 33.2906L35.9286 30.6147ZM22.4286 35.6086H27.5714V38.1657H22.4286V35.6086Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaGeneratorGreen);
export default __webpack_public_path__ + "static/media/idea_generator_green.dfa0f47ecb125d6165950e47becdb5af.svg";
export { ForwardRef as ReactComponent };